import React, { Component } from 'react';
import PropTypes from 'prop-types';
import appConfigs from '@nerdwallet/app-config';
import { Tracking as nwTracking } from '@nerdwallet/nw-client-lib';

import { getLogger } from '@nerdwallet/logging';
import rootLogger from '~/client/lib/logger-utils';

const logger = getLogger('safe', rootLogger);
class Safe extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      info: null,
    };
  }

  componentDidCatch(error, info) {
    this.setState({ error, info });
  }

  handleError() {
    const errorMessage = this.state.error.toString();
    const { componentStack } = this.state.info;

    if (appConfigs.CONFIG_ENV !== 'production') {
      return (
        <div>
          <h2>{errorMessage}</h2>
          <div>Component Stack Error Details:</div>
          <pre>{componentStack}</pre>
        </div>
      );
    }

    const error = {
      code: 'RenderingError',
      message: errorMessage,
      additionalData: JSON.stringify(componentStack),
    };
    logger.error('error while rendering component stack', error);
    nwTracking.errorEvent(error);

    return null;
  }

  render() {
    return this.state.error ? this.handleError() : this.props.children;
  }
}

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
Safe.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Safe;
